<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card>
      <v-card-title>
        <h2 style="font-size: 21px">
          {{ isEditing ? 'Editar' : 'Adicionar' }} Grupo de Filtros
        </h2>
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="currentGroup.name"
          placeholder="Nome do Grupo"
          class="primary-input"
          outlined
          hide-details="auto"
          required
          :rules="[(v) => !!v || 'Campo obrigatório']"
        ></v-text-field>

        <v-select
          v-model="currentGroup.filters"
          :items="institutions"
          placeholder="Instituições"
          class="primary-input"
          outlined
          hide-details="auto"
          multiple
          item-text="name"
          item-value="id"
          required
          :rules="[validateFilters]"
        ></v-select>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="primary-button ma-1 mb-4" depressed @click="closeDialog"
          >Cancelar</v-btn
        >
        <v-btn class="primary-button ma-1 mb-4" depressed @click="saveGroup"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    currentGroup: {
      type: Object,
      default: () => ({
        name: '',
        filters: [],
      }),
    },
    institutions: {
      type: Array,
      default: () => [],
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeDialog() {
      this.$emit('update:dialog', false)
      this.$emit('reset-group')
    },
    saveGroup() {
      this.$emit('save-group')
      this.closeDialog()
    },
    validateFilters(value) {
      return !!value.length || 'Campo obrigatório'
    },
  },
}
</script>
